import axios, { AxiosInstance, AxiosPromise } from 'axios';
import config from '@/appConfig.json';
import { Answer } from '@/store/models';
import { UserModule } from '@/store/modules/User';

export default class AnswerService {

	public static getInstance(): AnswerService {
		return new this();
	}
	private resourceUrl: string = '/answers/';

	private apiClient: AxiosInstance = axios.create({
		baseURL: config.apiUrl,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.accessToken
		}
	});

	/**
	 * Send answer to api.
	 * 
	 * @param questionId
	 * @param userId
	 * @param value
	 */
	public async saveAnswer(answer: Answer): Promise<any> {
		const success = await this.apiClient.post(
			this.resourceUrl,
			{
				question_id: answer.questionId,
				user_id: UserModule.userId,
				value: answer.value
			});

		return success.data;
	}

	public async loadAnswer(questionId: number): Promise<boolean> {
		const answer = await this.apiClient.get(this.resourceUrl, {
			params: {
				question_id: questionId,
				user_id: UserModule.userId
			}
		});
		return answer.data;
	}
}
